// extracted by mini-css-extract-plugin
module.exports = {"grid":"PaletteSelector_grid__1Ql-x"};